import React from 'react'
import { ChatMessagePage } from '../../../pages/ChatMessage/ChatMessagePage'

const ChatModal = ({ setIsModalChat }) => {

  return (
    <ChatMessagePage
      isModal
      setIsModalChat={setIsModalChat} />
  )
}

export default ChatModal